import { render, staticRenderFns } from "./properties.select.vue?vue&type=template&id=70592cf3"
import script from "./properties.select.vue?vue&type=script&lang=js"
export * from "./properties.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports